import { TYPE_SECURE, TYPE_FACEBOOK, TYPE_RHINOGRAM } from '../constants/Types';
import { DataHelpers } from '.';

// Communication ID refers to the id of a phone or facebook. In the future there may be more comm methods.
export function getCommunicationId(channelClassAndId) {
  return Number(channelClassAndId.substr(channelClassAndId.indexOf('-') + 1));
}

export function getChannelClassAndId(channel) {
  return `${channel.class}-${channel.id}`;
}

export function getChannelClass(channel) {
  return channel.substr(0, channel.indexOf('-'));
}

export function getChannelIcon(channelTypeId) {
  let icon = 'mobile';

  if (channelTypeId === TYPE_FACEBOOK) icon = 'facebook';
  else if (channelTypeId === TYPE_SECURE) icon = 'lock';
  else if (channelTypeId === TYPE_RHINOGRAM) icon = 'rhino';

  return icon;
}

export function formatRoute(route) {
  return DataHelpers.hasData(route) ? `${route.name} (${route.type})` : 'No route';
}
